export const defaultSeoEctoStatus = [
  { name: 'Mapeado' },
  { name: 'Impeditivo' },
  { name: 'Desenvolvimento' },
  { name: 'Entregue' },
  { name: 'Validação' },
  { name: 'Finalizado' },
];
